export default {
    SET_CAMPAIGN_BANNERS(state, campaignBanners) {
        state.campaignBanners = campaignBanners.items
        state.totalPages = campaignBanners.total_pages
    },
    ADD_CAMPAIGN_BANNER(state, campaignBanner) {
        state.campaignBanners.unshift(campaignBanner)
    },
    UPDATE_CAMPAIGN_BANNER(state, campaignBanner) {
        const campaignBannerIndex = state.campaignBanners.findIndex((u) => u.id === campaignBanner.id)
        Object.assign(state.campaignBanners[campaignBannerIndex], campaignBanner)
    },
    DELETE_CAMPAIGN_BANNER(state, campaignBannerId) {
        const ItemIndex = state.campaignBanners.findIndex((u) => u.id === campaignBannerId)
        state.campaignBanners.splice(ItemIndex, 1)
    },
    ADD_CAMPAIGN_BANNER_INFOS(state, campaignBanner) {
        state.campaignBannerInfos = campaignBanner
    },
    SET_CHOSEN_BANNER(state, { event, userId }) {
        if (event.userId === userId) {
            state.chosenBanner.position = event.position
            state.chosenBanner.direction = event.direction
            state.chosenBanner.hasBanner = event.hasBanner
        }

        state.chosenBanner.sentManually = event.sentManually === true
    },
    RESET_CHOSEN_BANNER(state) {
        state.chosenBanner.position = null
        state.chosenBanner.direction = null
        state.chosenBanner.hasBanner = false
    },
    SET_SOCKET_LISTENED(state) {
        state.socketListened = true
    },
    SET_LAST_NEWS(state, items) {
        state.lastNews = items[0] ? items[0] : null
    }
}
